export default {
	single_product: () => {
		import('./single-product');
	},
	tax_product_collection_model: () => {
		import('./tax-product-collection-model');
	},
	woocommerce_checkout: () => {
		import ('./woocommerce-checkout.js');
	}
};
